export default "__VITE_ASSET__BKJ5HUuX__"